export const SIGN_AT: string = '@';
export const SIGN_HASH: string = '#';
export const SIGN_PLUS: string = '+';
export const SIGN_DOT: string = '.';
export const SIGN_COMMA: string = ',';
